@if (settings$ | async; as settings) {
    @if (indstillinger$ | async; as indstillinger) {
        @if (!isLoginPage && useServiceProNavigation && !chrome.hideTopNavigation()) {
            <button class="skip-link" role="link" (click)="skipToContent()" (keyup.enter)="skipToContent()">
                Spring til hovedindhold
            </button>

            <top-navigation
                [aktuelBruger]="(aktuelBruger$ | async) ?? null"
                [aktuelForsyning]="(aktuelForsyningIndstillinger$ | async) ?? null"
                [indstillinger]="indstillinger"
                [menuItems]="bottomNavigationLinks"
            ></top-navigation>
        }
        <!-- Desktop -->
        @if (settings.isDesktop) {
            <div class="desktop-container">
                <ng-container *ngTemplateOutlet="leftmenu"></ng-container>
                <div>
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </div>
            </div>
        }
        <!-- Mobil -->
        @if (settings.isMobile) {
            <div class="navbar-mobile" [class.navbar-mobile--servicepro]="useServiceProNavigation" #navbarMobile>
                @if (!isLoginPage && !isTeknikerMode && !useServiceProNavigation) {
                    <div
                        id="mobile-menu-top-content"
                        class="navbar-mobile__top backgroundcolor2"
                        [class]="
                            scrollPositionTop || sidenavRight.opened || sidenavLeft.opened || fofBruger
                                ? ''
                                : 'on-scroll'
                        "
                    >
                        @if (indstillinger.eforsyninger?.length) {
                            <button
                                id="LeftMobileMenuButton"
                                class="menu-button left"
                                #LeftMobileMenuButton
                                type="button"
                                role="button"
                                aria-controls="sidenavLeft"
                                [attr.aria-expanded]="sidenavLeft.opened ? true : false"
                                [attr.aria-label]="sidenavLeft.opened ? 'Luk sidemenu' : 'Åben sidemenu'"
                                (click)="sidenavLeft.toggle(); sidenavRight.close()"
                            >
                                <mat-icon [svgIcon]="eforsyningIcon$ | async"></mat-icon>
                                @if ((eforsyningIcon$ | async) === "lock-open") {
                                    <span>E|Forsyning</span>
                                }
                                @if (burgerMenuBadge$ | async) {
                                    <span class="burger-menu-dot"></span>
                                }
                            </button>
                        }

                        <a [href]="indstillinger.forsyningWeb?.siteUrl">
                            @if (indstillinger.logoUrl) {
                                <img [alt]="indstillinger.firmaNavn" [src]="indstillinger.logoUrl" />
                            }
                            @if (!indstillinger.logoUrl) {
                                <span>{{ indstillinger.firmaNavn }}</span>
                            }
                        </a>

                        <div class="navbar-mobile__actions">
                            @if (!hideForsyningWebMenu && indstillinger?.forsyningWeb.nodeId) {
                                <button
                                    id="RightMobileMenuButton"
                                    class="menu-button right"
                                    #RightMobileMenuButton
                                    type="button"
                                    role="button"
                                    aria-controls="sidenavRight"
                                    [attr.aria-expanded]="sidenavRight.opened ? true : false"
                                    [attr.aria-label]="sidenavRight.opened ? 'Luk hovedmenu' : 'Åben hovedmenu'"
                                    (click)="sidenavRight.toggle(); sidenavLeft.close()"
                                >
                                    <mat-icon svgIcon="menu-forsyning-web"></mat-icon>
                                    <span>Forsyning|Web</span>
                                </button>
                            }
                        </div>
                    </div>

                    <div
                        id="mobile-menu-bottom-content"
                        class="navbar-mobile__bottom backgroundcolor2"
                        [class]="
                            scrollPositionTop || sidenavRight.opened || sidenavLeft.opened || fofBruger
                                ? ''
                                : 'on-scroll'
                        "
                    >
                        <ng-container *ngTemplateOutlet="vaelgInstallation"></ng-container>
                        <ng-container *ngTemplateOutlet="breadcrumb"></ng-container>
                        @if (settings.visDriftsstatus) {
                            <driftsstatus-knap
                                class="backgroundcolor2"
                                titel="Driftsstatus"
                                [visIkon]="false"
                            ></driftsstatus-knap>
                        }
                    </div>
                }
            </div>
            <!-- content -->
            <div
                class="sidenav-wrapper"
                [style.top.px]="
                    useServiceProNavigation
                        ? 0
                        : scrollPositionTop || sidenavRight.opened || sidenavLeft.opened || fofBruger
                          ? (navbarMobileHeight$ | async)
                          : (navbarMobileHeight$ | async) - 65
                "
            >
                <mat-sidenav-container #sidenavContainer>
                    <mat-sidenav #sidenavLeft>
                        <eforsyning-sidenav-menu
                            id="sidenavLeft"
                            type="navigation"
                            [visLoggetUdMenu]="true"
                            role="navigation"
                            [attr.aria-expanded]="sidenavLeft.opened"
                            [attr.aria-hidden]="!sidenavLeft.opened"
                            aria-label="Side menu"
                            aria-labelledby="LeftMobileMenuButton"
                            (itemClick)="sidenavContainer.close()"
                        ></eforsyning-sidenav-menu>
                    </mat-sidenav>
                    <mat-sidenav
                        id="sidenavRight"
                        [class.servicepro-hide-forsyningweb]="hideForsyningWebMenu"
                        #sidenavRight
                        position="end"
                        type="navigation"
                        role="navigation"
                        [attr.aria-expanded]="hideForsyningWebMenu ? false : sidenavRight.opened"
                        [attr.aria-hidden]="hideForsyningWebMenu ? true : !sidenavRight.opened"
                        aria-label="Hoved menu"
                        aria-labelledby="RightMobileMenuButton"
                    >
                        @if (!hideForsyningWebMenu) {
                            <forsyningweb-sidenav-menu
                                (itemClick)="sidenavContainer.close()"
                            ></forsyningweb-sidenav-menu>
                        }
                    </mat-sidenav>
                    <mat-sidenav-content id="MatSidenavContent" #sidenavContent>
                        <ng-container *ngTemplateOutlet="content"></ng-container>
                    </mat-sidenav-content>
                </mat-sidenav-container>
            </div>
        }
        @if (!isLoginPage && settings.isMobile && useServiceProNavigation && !chrome.hideBottomNavigation()) {
            <bottom-navigation [menuItems]="bottomNavigationLinks"></bottom-navigation>
        }
        @if (isLoginPage && useServiceProNavigation) {
            <service-pro-cookie-consent-button
                class="service-pro-cookie-consent"
                [isLoginPage]="true"
            ></service-pro-cookie-consent-button>
        }
    }
}

<!-- Indhold, indsættes i enten Desktop eller Mobil-containeren -->
<ng-template #content><ng-content></ng-content></ng-template>
<ng-template #breadcrumb><ng-content select=".breadcrumb"></ng-content></ng-template>
<ng-template #vaelgInstallation><ng-content select=".vaelg-installation"></ng-content></ng-template>
<ng-template #leftmenu><ng-content select=".leftmenu"></ng-content></ng-template>

@if (!useServiceProNavigation) {
    <eforsyning-app-rating-banner></eforsyning-app-rating-banner>
}
